import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BRAND_ASSETS_AUTHORIZED, LOGO_AVANTI_WHITE } from '../data/contact';
import { Footer } from './Footer';
interface LegalPageLayoutProps {
  title: string;
  updated: string;
  children: React.ReactNode;
}
export function LegalPageLayout({
  title,
  updated,
  children
}: LegalPageLayoutProps) {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  return <div className="w-full bg-white" data-id="element-329" data-mp="22zpibwptd5y">
      <header className="w-full bg-midnight" data-id="element-330" data-mp="21ygse3692re">
        <div className="mx-auto flex max-w-editorial items-center justify-between gap-4 px-5 py-4 lg:px-8" data-id="element-331" data-mp="3t9kn6eh9zjby">
          <Link to="/" className="flex items-center gap-4" data-id="element-332" data-mp="3ob9dc3qzd8tq">
            <span data-id="element-333" data-mp="3o8mxzhxulp0y">
              <span className="block font-display text-xl uppercase tracking-[0.28em] text-white" data-id="element-334" data-mp="3jbmyxqzf1mjc">
                VERO
              </span>
              <span className="mt-1 block text-[9px] uppercase tracking-[0.14em] text-gold" data-id="element-335" data-mp="3fb4a85stkwld">
                {t('Affiliated with Avanti Way Realty LLC', 'Afiliada a Avanti Way Realty LLC')}
              </span>
            </span>
            {BRAND_ASSETS_AUTHORIZED && <img src={LOGO_AVANTI_WHITE} alt="Avanti Way Realty LLC." className="hidden h-auto w-[110px] border-l border-white/20 pl-4 sm:block" width={110} height={22} data-id="element-336" data-mp="222g6hktlvml3" />}
          </Link>

          <div className="flex items-center gap-5" data-id="element-337" data-mp="2zq858j8bavus">
            <div className="flex items-center gap-1 text-[11px] tracking-[0.12em] text-white/70" role="group" aria-label={t('Language selector', 'Selector de idioma')} data-id="element-338" data-mp="2zox12iayfm35">
              <button type="button" onClick={() => setLang('en')} aria-pressed={lang === 'en'} className={lang === 'en' ? 'text-gold' : 'hover:text-white'} data-id="element-339" data-mp="1aarx9764jg6h">
                EN
              </button>
              <span aria-hidden="true" className="text-white/30" data-id="element-340" data-mp="3h13mpzxv0did">|</span>
              <button type="button" onClick={() => setLang('es')} aria-pressed={lang === 'es'} className={lang === 'es' ? 'text-gold' : 'hover:text-white'} data-id="element-341" data-mp="3c18u9ryfrfv7">
                ES
              </button>
            </div>
            <Link to="/" className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.14em] text-white/80 transition-colors duration-150 ease-out hover:text-gold" data-id="element-342" data-mp="2y9atc4evoqa4">
              <ArrowLeftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-343" data-mp="2oalmr7sfms96" />
              {t('Back to property', 'Volver a la propiedad')}
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-16 lg:px-8 lg:py-24" data-id="element-344" data-mp="mi776fdd1zvx">
        <h1 className="font-display text-[34px] font-semibold uppercase leading-[1.05] text-midnight lg:text-[44px]" data-id="element-345" data-mp="hkyo8cke1rtm">
          {title}
        </h1>
        <div className="gold-rule mt-6 w-24" data-id="element-346" data-mp="pz3a1hzapwn5" />
        <p className="label-caps mt-6 text-ink/55" data-id="element-347" data-mp="u1g4vbci8a55">{updated}</p>
        <div className="mt-10 space-y-8 text-[15px] leading-relaxed text-ink/80" data-id="element-348" data-mp="yt7v1krr0dur">{children}</div>
      </main>

      <Footer data-id="element-349" data-mp="13s18xeay66vg" />
    </div>;
}
export function LegalHeading({
  children
}: {
  children: React.ReactNode;
}) {
  return <h2 className="font-display text-[20px] font-medium uppercase tracking-[0.06em] text-midnight" data-id="element-350" data-mp="72tlu1uojppf">
      {children}
    </h2>;
}